// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"f3bff1e5","56":"4c36ef92","449":"3c694abc","539":"f30ec58a","638":"1836d16c","777":"0640b042"}[chunkId] + ".chunk.js";
};